import { createAsyncThunk } from '@reduxjs/toolkit'

import { GetUsersRequest } from '../api/types'
import { UsersApi } from '../api/usersApi'

// ---------------------------------------------------------------------

export const SLICE_NAME = 'users'

export const GetUsers = createAsyncThunk(
  `${SLICE_NAME}/getUsers`,
  async (data: GetUsersRequest, thunkAPI) => {
    const res = await UsersApi.getAllUsers(data)

    if (res.success) return res

    return thunkAPI.rejectWithValue(null)
  },
)
